import get from 'lodash/get';
import Cookies from "js-cookie";
import jwtDecode from 'jwt-decode';

const getPlayerSize = (width) => {
    if(width > 1024) return 'L';
    if(width > 768) return 'M';
    return 'S';
}

const getKeywords = (props) => {
    const tags = get(props, 'video.tags', []);
    const category = get(get(props, 'video.gist.primaryCategory.title', 'VIEWLIFT_CONTENT_GENRE'));
    if(tags.length > 0){
        return tags.map(tag=>tag.title).join(',');
    }
    return category;
}

const getIpAddress = () => {
    const token = JSON.parse(window.localStorage.getItem("token"));
    if(!token || !token.authorizationToken) return 'VIEWLIFT_IP';
    const { ipaddress, ipaddresses } = jwtDecode(token.authorizationToken);
    return ipaddress || ipaddresses || 'VIEWLIFT_IP';
}

export const replaceMacros = (assetUrl = '', props, vjsObj, autoplay, muted ) => {
    if(!assetUrl.includes('VIEWLIFT_')) return assetUrl;
    const { width, height } = vjsObj.dimensions;
    const contentId = get(props, 'video.gist.id', '');
    const adsTag = get(window.settings, 'advertising.videoTag', '');
    const adsTagParams = new URLSearchParams(adsTag);
    
    const macroMap = {
        'VIEWLIFT_WIDTH': width,
        'VIEWLIFT_HEIGHT': height,
        'VIEWLIFT_SIZE': getPlayerSize(width),
        'VIEWLIFT_DOMAIN': window.location.hostname,
        'VIEWLIFT_URL': window.location.href,
        'VIEWLIFT_ENCODED_URL': encodeURIComponent(window.location.href),
        'VIEWLIFT_DOUBLE_ENCODED_URL': encodeURIComponent(encodeURIComponent(window.location.href)),
        'VIEWLIFT_CACHEBUSTER': '3708662946268',
        'VIEWLIFT_TIMESTAMP': Date.now().toString().substring(0,10),
        'VIEWLIFT_TIMESTAMP_MS': Date.now().toString(),
        'VIEWLIFT_IP': getIpAddress(),
        'VIEWLIFT_USER_AGENT': navigator.userAgent,
        'VIEWLIFT_DNT': navigator.doNotTrack === '1' ? '1' : '0',
        'VIEWLIFT_DESCRIPTION': get(props, 'video.gist.description', 'VIEWLIFT_DESCRIPTION'),
        'VIEWLIFT_DURATION': get(props, 'video.gist.runtime', 'VIEWLIFT_DURATION'),
        'VIEWLIFT_MIN_DURATION': 0,
        'VIEWLIFT_MAX_DURATION': get(props, 'video.gist.runtime', 'VIEWLIFT_DURATION'),
        'VIEWLIFT_AUTOPLAY': autoplay || 1,
        'VIEWLIFT_AD_POS': adsTagParams.get('pod') || 'VIEWLIFT_AD_POS',
        'VIEWLIFT_MUTE': muted || 0,
        'VIEWLIFT_OS': get(window, '_deviceInfo.os.name', 'VIEWLIFT_OS'),
        'VIEWLIFT_OS_VER': get(window, '_deviceInfo.os.version', 'VIEWLIFT_OS_VER'),
        'VIEWLIFT_DEVICE_ID': localStorage.getItem('deviceId') || 'VIEWLIFT_DEVICE_ID',
        'VIEWLIFT_KEYWORDS': getKeywords(props),
        'VIEWLIFT_MEDIA_ID': contentId,
        'VIEWLIFT_ENCODED_VIDEO_TITLE': encodeURI(get(props, 'video.gist.title', 'VIEWLIFT_ENCODED_VIDEO_TITLE')),
        'VIEWLIFT_VIDEO_ID': contentId,
        'VIEWLIFT_VIDEO_URL': encodeURI(window.location.host + get(props, 'video.gist.permalink','')),
        'VIEWLIFT_CONSENT': Cookies.get("cc") || 'VIEWLIFT_CONSENT',
        'VIEWLIFT_COPPA': get(window.settings, 'compliance.coppa') ? 1 : 0,
        'VIEWLIFT_GDPR': get(window.settings, 'compliance.gdpr') ? 1 : 0,
        'VIEWLIFT_US_PRIVACY':Cookies.get("cc") && Cookies.get("cc").toString().toUpperCase().includes('PRIVACY') ? Cookies.get("cc") : 'VIEWLIFT_US_PRIVACY',
        'VIEWLIFT_CONTENT_DURATION_MS': get(props, 'video.gist.runtime', 'VIEWLIFT_DURATION') * 1000,
        'VIEWLIFT_CONTENT_DURATION': get(props, 'video.gist.runtime', 'VIEWLIFT_DURATION'),
        'VIEWLIFT_MAX_POD_DURATION': adsTagParams.get('pmxd') || 'VIEWLIFT_MAX_POD_DURATION',
        'VIEWLIFT_MAX_POD_DURATION_MS': adsTagParams.get('pmxd') * 1000 || 'VIEWLIFT_MAX_POD_DURATION_MS',
        'VIEWLIFT_CONTENT_ID': contentId,
        'VIEWLIFT_CONTENT_TITLE': get(props, 'video.gist.title', 'VIEWLIFT_ENCODED_VIDEO_TITLE'),
        'VIEWLIFT_CONTENT_SERIES_TITLE': get(props, 'video.series[0].gist.title', get(props, 'seriesInfo.title', 'VIEWLIFT_CONTENT_SERIES_TITLE')),
        'VIEWLIFT_CONTENT_EPISODE': get(props, 'video.currentEpisode', 'VIEWLIFT_CONTENT_EPISODE'),
        'VIEWLIFT_CONTENT_SEASON': get(props, 'video.currentSeason', 'VIEWLIFT_CONTENT_SEASON'),
        'VIEWLIFT_CONTENT_GENRE': get(props, 'video.gist.primaryCategory.title', 'VIEWLIFT_CONTENT_GENRE')
    }
    for(let key in macroMap){
        const curReg = new RegExp(key, 'g');
        assetUrl = assetUrl.replace(curReg, macroMap[key])
    }

    return assetUrl;
}